import React from "react";
import { Container, Button, Row, Col, Card, Badge } from "react-bootstrap";
import { FaHandshake, FaGraduationCap, FaSearch, FaUserCheck, FaRocket, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Students = () => {
  const mainColor = '#006186';

  return (
    <div className="min-vh-100" >
      <section className="news-hero py-5 border-bottom">
        <Container className="students-hero">
          <h1 className="fw-bold display-5 mb-3" style={{ color: mainColor }}>Менторская программа ОшТУ</h1>
          <p className="lead text-muted mx-auto" >
            Профессиональный мост между поколениями. Опыт выпускников помогает талантам студентов раскрыться.
          </p>
        </Container>
      </section>

      <Container className="py-5">
        {/* Как это работает — Карточки как в Контактах (белые, с тенью) */}
        <h4 className="fw-bold mb-4 border-start border-4 ps-3" style={{ borderColor: mainColor }}>
          Этапы взаимодействия
        </h4>
        <Row className="g-4 mb-5">
          {[
            { icon: <FaUserCheck />, title: "Регистрация", text: "Заполните профиль, укажите свои навыки и цели." },
            { icon: <FaSearch />, title: "Поиск пары", text: "Выберите наставника из каталога или по рекомендации." },
            { icon: <FaRocket />, title: "Работа", text: "Встречи, консультации и совместные проекты." }
          ].map((step, idx) => (
            <Col md={4} key={idx}>
              <Card className="h-100 border-0 shadow-sm p-4 rounded-4">
                <div className="mb-3" style={{ color: mainColor }}><span className="fs-3">{step.icon}</span></div>
                <h5 className="fw-bold">{step.title}</h5>
                <p className="small text-muted mb-0">{step.text}</p>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Основные блоки — Адаптивная сетка (по 2 в ряд на ПК, по 1 на мобильных) */}
        <Row className="g-4">
          {/* Блок МЕНТОРА */}
          <Col lg={6}>
            <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden border-top border-4" style={{ borderColor: '#dc3545' }}>
              <Card.Body className="p-4 p-md-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="bg-danger bg-opacity-10 p-3 rounded-3 me-3 text-danger">
                    <FaHandshake size={28} />
                  </div>
                  <div>
                    <h3 className="fw-bold mb-0">Стать Ментором</h3>
                    <small className="text-muted">Для опытных выпускников</small>
                  </div>
                </div>
                <ul className="list-unstyled mb-5">
                  {['Помощь студентам в старте карьеры', 'Поиск талантов в свою команду', 'Развитие лидерских качеств'].map((li, i) => (
                    <li key={i} className="mb-2 d-flex align-items-center text-secondary small">
                      <FaChevronRight size={12} className="me-2 text-danger" /> {li}
                    </li>
                  ))}
                </ul>
                <Button as={Link} to="/register-mentor" variant="danger" className="w-100 rounded-pill py-2 fw-bold shadow-sm">
                  Заполнить анкету
                </Button>
              </Card.Body>
            </Card>
          </Col>

          {/* Блок МЕНТИ */}
          <Col lg={6}>
            <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden border-top border-4" style={{ borderColor: mainColor }}>
              <Card.Body className="p-4 p-md-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-3 me-3" style={{ color: mainColor }}>
                    <FaGraduationCap size={28} />
                  </div>
                  <div>
                    <h3 className="fw-bold mb-0">Стать Менти</h3>
                    <small className="text-muted">Для активных студентов</small>
                  </div>
                </div>
                <ul className="list-unstyled mb-5 text-secondary">
                  {['Советы от практиков бизнеса', 'Помощь с дипломным проектом', 'Индивидуальный план развития'].map((li, i) => (
                    <li key={i} className="mb-2 d-flex align-items-center small">
                      <FaChevronRight size={12} className="me-2 text-primary" /> {li}
                    </li>
                  ))}
                </ul>
                <Button as={Link} to="/find-mentor" variant="primary" className="w-100 rounded-pill py-2 fw-bold shadow-sm" style={{ backgroundColor: mainColor, border: 'none' }}>
                  Найти наставника
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Students;